var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsApiGateway(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2065,
    height: 2500,
    viewBox: "0 0 256 310",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 137.042l-62.152 2.575-40.289-2.57 66.64-6.387L256 137.042",
    fill: "#634B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.055 133.45L256 137.042V64.636l-35.945-17.975-2.76 2.98v80.728l2.76 3.081",
    fill: "#D9A740"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.559 64.594l66.496-17.997v86.853l-66.496 3.597V64.594",
    fill: "#886A2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 137.042l62.152 2.575 40.289-2.57-66.45-7.117L0 137.042",
    fill: "#634B1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.945 133.45L0 136.935V64.31l35.945-17.945 1.655 3.091v81.281l-1.655 2.713",
    fill: "#886A2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.441 64.594L35.945 46.597v86.853l66.496 3.597V64.594",
    fill: "#D9A740"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256 174.486l-62.152-2.576-40.289 2.571 66.35 6.707L256 174.486",
    fill: "#FAD791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.055 178.078L256 174.486v72.405l-35.945 17.975-1.888-4.111v-78.983l1.888-3.694",
    fill: "#D9A740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.559 246.934l66.496 17.997v-86.853l-66.496-3.597v72.453",
    fill: "#886A2A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 174.486l62.152-2.576 40.289 2.571-66.931 7.288L0 174.486",
    fill: "#FAD791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.945 178.078L0 174.486v72.405l35.945 17.975 2.179-3.24v-79.857l-2.179-3.691",
    fill: "#886A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.441 246.934l-66.496 17.997v-86.853l66.496-3.597v72.453",
    fill: "#D9A740"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.553 106.629l32.966-5.781 65.814 9.319 5.669 3.261-31.966 3.498-72.483-10.297",
    fill: "#634B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.447 106.629l-32.966-5.781L58.833 111.5l-2.835 1.928 31.966 3.498 72.483-10.297",
    fill: "#634B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.553 204.899l32.966 5.781 65.648-9.18 5.835-3.4-31.966-3.498-72.483 10.297",
    fill: "#FAD791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.447 204.899l-32.966 5.781-69.148-9.847-2.335-2.733 31.966-3.498 72.483 10.297",
    fill: "#FAD791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.002 113.428V77.641l-33.713-11.025v-46.84L128 .634v.001l-1.597 2.543-.291 302.588 1.888 3.891 38.289-19.142v-45.603l33.713-11.025V198.1l-33.713 5.935v-96.542l33.713 5.935",
    fill: "#D9A740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.711 19.776v46.84L55.998 77.641v35.787l33.713-5.935v96.542L55.998 198.1v35.787l33.713 11.025v45.603L128 309.657V.634L89.711 19.776",
    fill: "#886A2A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsApiGateway);
export default __webpack_public_path__ + "static/media/aws-api-gateway.1de9f8ac8c5d4da2174465378fb00971.svg";
export { ForwardRef as ReactComponent };